import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from 'date-fns';

const getBrasiliaDate = () => {
  const brasiliaString = new Date().toLocaleString('en-US', {
    timeZone: 'America/Sao_Paulo'
  });
  return new Date(brasiliaString);
};


//NOTE: Essa função retorna a hora cheia exata para ser usada como filtro 
// na lista de metas por horario das cidades
export const brasiliaTimeHour = format(getBrasiliaDate(), 'HH:00'); 

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getCode(digitos = 7) {
  const min = Math.pow(10, digitos - 1);
  const max = Math.pow(10, digitos) - 1;
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
